import { useNavigate } from 'react-router-dom';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import { prevBusinessIdKey } from '~/hooks/useSwitchBusiness';
import { useStore, useStoreActions } from '~/store/store-context';
export const handleCreateVendorAccountApprove = async (userInfo, api, logBI, reportToHeap, reportToHubspot)=>{
    logBI(18101);
    reportToHubspot('create_vendor_account_approve_v4');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasApprovedTermsOfService())) {
        const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
        if (userId) {
            await api.auth.approveTos(userId);
        }
    }
};
export const useCreateVendorAccount = (onClick)=>{
    const userInfo = useStore((state)=>state.userInfo);
    const { setWorksAt, api, logBI } = useStoreActions();
    const { reportToHeap, reportToHubspot } = useEventReporter();
    const { localStorage } = useIoContext();
    const navigate = useNavigate();
    const onCreateVendorAccount = async ()=>{
        onClick === null || onClick === void 0 ? void 0 : onClick();
        reportToHubspot('create_vendor_account_clicked_v2');
        reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
        await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
        const previousBusinessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
        if (previousBusinessId) {
            localStorage.setItem(prevBusinessIdKey, previousBusinessId);
        }
        setWorksAt();
        navigate(routes.vendorOnboarding, {
            replace: true
        });
    };
    return onCreateVendorAccount;
};
